// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.components-ImportEmployees-styles___button--_Cwdw {
  font-weight: normal;
  text-transform: capitalize;
  width: 200px;
  padding: 0;
}

.components-ImportEmployees-styles___upload-content--jT8FM {
  margin: 10px 11px;
  min-width: 700px;
}

.components-ImportEmployees-styles___upload-content--jT8FM .components-ImportEmployees-styles___textField--sMh73 {
    margin: 15px 0 10px 0 !important;
  }

.components-ImportEmployees-styles___upload-content--jT8FM .components-ImportEmployees-styles___import-employees--af9zx {
    cursor: pointer;
    margin: 14px 0 0 0;
    text-align: left;
    color: #318afb;
    font-size: 14px;
  }

.components-ImportEmployees-styles___upload-content--jT8FM .components-ImportEmployees-styles___import-employees--af9zx * {
      vertical-align: middle;
      margin-right: 16px;
    }

.components-ImportEmployees-styles___upload-content--jT8FM .components-ImportEmployees-styles___file-name--rtXDD {
    text-align: left;
    font-size: 14px;
  }

.components-ImportEmployees-styles___upload-content--jT8FM .components-ImportEmployees-styles___file-name--rtXDD::after {
      content: ' ';
    }

.components-ImportEmployees-styles___upload-content--jT8FM .components-ImportEmployees-styles___bottom--GOu1J {
    display: flex;
    align-items: center;
  }

.components-ImportEmployees-styles___upload-content--jT8FM .components-ImportEmployees-styles___bottom--GOu1J .components-ImportEmployees-styles___checkboxContainer--GsCMC {
      display: flex;
    }

.components-ImportEmployees-styles___upload-content--jT8FM .components-ImportEmployees-styles___bottom--GOu1J .components-ImportEmployees-styles___checkboxContainer--GsCMC > span {
        padding: 0 8px 0 0;
      }

.components-ImportEmployees-styles___upload-content--jT8FM .components-ImportEmployees-styles___bottom--GOu1J .components-ImportEmployees-styles___checkboxContainer--GsCMC .components-ImportEmployees-styles___checkBoxText--uIVCM {
        cursor: pointer;
      }

.components-ImportEmployees-styles___upload-content--jT8FM .components-ImportEmployees-styles___actions--lotnd {
    display: flex;
    min-width: 500px;
    text-align: left;
    align-items: center;

    margin-top: 30px;
    margin-bottom: 6px;
    justify-content: flex-end;
  }

.components-ImportEmployees-styles___upload-content--jT8FM .components-ImportEmployees-styles___actions--lotnd .components-ImportEmployees-styles___download-link--iqSp0,
    .components-ImportEmployees-styles___upload-content--jT8FM .components-ImportEmployees-styles___actions--lotnd .components-ImportEmployees-styles___button--_Cwdw {
      flex: 1 0 0;
    }

.components-ImportEmployees-styles___upload-content--jT8FM .components-ImportEmployees-styles___actions--lotnd .components-ImportEmployees-styles___download-link--iqSp0 {
      font-size: 13px;
      color: #6d717a;
    }

.components-ImportEmployees-styles___upload-content--jT8FM .components-ImportEmployees-styles___actions--lotnd .components-ImportEmployees-styles___download-link--iqSp0 > a {
        color: #318afb;
      }

.components-ImportEmployees-styles___upload-content--jT8FM .components-ImportEmployees-styles___actions--lotnd .components-ImportEmployees-styles___button--_Cwdw {
      text-align: right;
      max-width: 150px;
    }

.components-ImportEmployees-styles___upload-content--jT8FM .components-ImportEmployees-styles___actions-right--mv2s1 {
    justify-content: flex-end;
  }

.components-ImportEmployees-styles___upload-content--jT8FM .components-ImportEmployees-styles___actions-right--mv2s1 .components-ImportEmployees-styles___button--_Cwdw {
      flex: 0 1 200px;
    }

.components-ImportEmployees-styles___upload-content--jT8FM .components-ImportEmployees-styles___error-message--IYtGo {
    font-size: 12px;
    text-align: left;
    color: #ff0000;
  }

.components-ImportEmployees-styles___upload-content--jT8FM .components-ImportEmployees-styles___error-file-name--h2b6q {
    border-bottom: 1px solid #ff0000;
  }

.components-ImportEmployees-styles___report-content--LK21x {
  margin: 10px 20px;
  min-width: 1200px;
  text-align: left;
}

.components-ImportEmployees-styles___report-content--LK21x p {
    margin: 20px 0 40px 0;
    font-size: 13px;
  }

.components-ImportEmployees-styles___report-content--LK21x .components-ImportEmployees-styles___actions--lotnd {
    margin: 20px 0;
    display: flex;
    justify-content: flex-end;
  }

.components-ImportEmployees-styles___report-content--LK21x .components-ImportEmployees-styles___actions--lotnd > .components-ImportEmployees-styles___button--_Cwdw {
      flex: 0 1 auto;
    }

.components-ImportEmployees-styles___loading-content--O5Bd7 {
  margin: 10px 20px;
  min-width: 600px;
  min-height: 130px;
}

.components-ImportEmployees-styles___tabs--PaV7p {
  margin-bottom: 24px;
}

.components-ImportEmployees-styles___importEmployees--MLCRv {
  border-radius: 6px;
  display: flex;
  justify-content: center;
  height: 71px;
  border: 1px dashed #e0e2e6;
  align-items: center;
  cursor: pointer;
}

.components-ImportEmployees-styles___importEmployees--MLCRv svg {
    margin-right: 8px;
  }

.components-ImportEmployees-styles___importEmployees--MLCRv span {
  cursor: pointer;
  color: #318afb;
  font-size: 17px;
  font-family: Roboto;
  letter-spacing: 0;
  font-family: 'Roboto-Medium', 'Roboto';
}

.components-ImportEmployees-styles___changeFile--Tr4IT {
  font-family: 'Roboto-Medium', 'Roboto';
  font-size: 15px;
  color: #318afb;
  letter-spacing: 0;
  text-align: center;
  font-weight: 600;
}

.components-ImportEmployees-styles___fileCheckIcon--DtBFh {
  font-family: 'Roboto-Medium', 'Roboto';
  font-size: 15px;
  color: #1b2432;
  letter-spacing: 0;
  text-align: center;
  margin-right: 8px;
}

.components-ImportEmployees-styles___fileContainer--bNcXq {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  padding: 12px;
  padding-left: 24px;
  padding-right: 24px;
}

.components-ImportEmployees-styles___fileNameContainer--zemRH {
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: 'Roboto-Medium', 'Roboto';
  font-weight: 600;
}
`, "",{"version":3,"sources":["webpack://./components/ImportEmployees/styles.pcss"],"names":[],"mappings":"AAAA;EACE,mBAAmB;EACnB,0BAA0B;EAC1B,YAAY;EACZ,UAAU;AACZ;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AA4FlB;;AA1FE;IACE,gCAAgC;EAClC;;AAEA;IACE,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,cAAc;IACd,eAAe;EAMjB;;AAJE;MACE,sBAAsB;MACtB,kBAAkB;IACpB;;AAGF;IACE,gBAAgB;IAChB,eAAe;EAKjB;;AAHE;MACE,YAAY;IACd;;AAGF;IACE,aAAa;IACb,mBAAmB;EAarB;;AAXE;MACE,aAAa;IASf;;AAPE;QACE,kBAAkB;MACpB;;AAEA;QACE,eAAe;MACjB;;AAIJ;IACE,aAAa;IACb,gBAAgB;IAChB,gBAAgB;IAChB,mBAAmB;;IAEnB,gBAAgB;IAChB,kBAAkB;IAClB,yBAAyB;EAoB3B;;AAlBE;;MAEE,WAAW;IACb;;AAEA;MACE,eAAe;MACf,cAAc;IAKhB;;AAHE;QACE,cAAc;MAChB;;AAGF;MACE,iBAAiB;MACjB,gBAAgB;IAClB;;AAGF;IACE,yBAAyB;EAK3B;;AAHE;MACE,eAAe;IACjB;;AAGF;IACE,eAAe;IACf,gBAAgB;IAChB,cAAc;EAChB;;AAEA;IACE,gCAAgC;EAClC;;AAGF;EACE,iBAAiB;EACjB,iBAAiB;EACjB,gBAAgB;AAgBlB;;AAdE;IACE,qBAAqB;IACrB,eAAe;EACjB;;AAEA;IACE,cAAc;IACd,aAAa;IACb,yBAAyB;EAK3B;;AAHE;MACE,cAAc;IAChB;;AAIJ;EACE,iBAAiB;EACjB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,YAAY;EACZ,0BAA0B;EAC1B,mBAAmB;EACnB,eAAe;AAKjB;;AAHE;IACE,iBAAiB;EACnB;;AAGF;EACE,eAAe;EACf,cAAc;EACd,eAAe;EACf,mBAAmB;EACnB,iBAAiB;EACjB,sCAAsC;AACxC;;AAEA;EACE,sCAAsC;EACtC,eAAe;EACf,cAAc;EACd,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,sCAAsC;EACtC,eAAe;EACf,cAAc;EACd,iBAAiB;EACjB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,WAAW;EACX,aAAa;EACb,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,sCAAsC;EACtC,gBAAgB;AAClB","sourcesContent":[".button {\n  font-weight: normal;\n  text-transform: capitalize;\n  width: 200px;\n  padding: 0;\n}\n\n.upload-content {\n  margin: 10px 11px;\n  min-width: 700px;\n\n  .textField {\n    margin: 15px 0 10px 0 !important;\n  }\n\n  .import-employees {\n    cursor: pointer;\n    margin: 14px 0 0 0;\n    text-align: left;\n    color: #318afb;\n    font-size: 14px;\n\n    * {\n      vertical-align: middle;\n      margin-right: 16px;\n    }\n  }\n\n  .file-name {\n    text-align: left;\n    font-size: 14px;\n\n    &::after {\n      content: ' ';\n    }\n  }\n\n  .bottom {\n    display: flex;\n    align-items: center;\n\n    .checkboxContainer {\n      display: flex;\n\n      > span {\n        padding: 0 8px 0 0;\n      }\n\n      .checkBoxText {\n        cursor: pointer;\n      }\n    }\n  }\n\n  .actions {\n    display: flex;\n    min-width: 500px;\n    text-align: left;\n    align-items: center;\n\n    margin-top: 30px;\n    margin-bottom: 6px;\n    justify-content: flex-end;\n\n    .download-link,\n    .button {\n      flex: 1 0 0;\n    }\n\n    .download-link {\n      font-size: 13px;\n      color: #6d717a;\n\n      > a {\n        color: #318afb;\n      }\n    }\n\n    .button {\n      text-align: right;\n      max-width: 150px;\n    }\n  }\n\n  .actions-right {\n    justify-content: flex-end;\n\n    .button {\n      flex: 0 1 200px;\n    }\n  }\n\n  .error-message {\n    font-size: 12px;\n    text-align: left;\n    color: #ff0000;\n  }\n\n  .error-file-name {\n    border-bottom: 1px solid #ff0000;\n  }\n}\n\n.report-content {\n  margin: 10px 20px;\n  min-width: 1200px;\n  text-align: left;\n\n  p {\n    margin: 20px 0 40px 0;\n    font-size: 13px;\n  }\n\n  .actions {\n    margin: 20px 0;\n    display: flex;\n    justify-content: flex-end;\n\n    > .button {\n      flex: 0 1 auto;\n    }\n  }\n}\n\n.loading-content {\n  margin: 10px 20px;\n  min-width: 600px;\n  min-height: 130px;\n}\n\n.tabs {\n  margin-bottom: 24px;\n}\n\n.importEmployees {\n  border-radius: 6px;\n  display: flex;\n  justify-content: center;\n  height: 71px;\n  border: 1px dashed #e0e2e6;\n  align-items: center;\n  cursor: pointer;\n\n  svg {\n    margin-right: 8px;\n  }\n}\n\n.importEmployees span {\n  cursor: pointer;\n  color: #318afb;\n  font-size: 17px;\n  font-family: Roboto;\n  letter-spacing: 0;\n  font-family: 'Roboto-Medium', 'Roboto';\n}\n\n.changeFile {\n  font-family: 'Roboto-Medium', 'Roboto';\n  font-size: 15px;\n  color: #318afb;\n  letter-spacing: 0;\n  text-align: center;\n  font-weight: 600;\n}\n\n.fileCheckIcon {\n  font-family: 'Roboto-Medium', 'Roboto';\n  font-size: 15px;\n  color: #1b2432;\n  letter-spacing: 0;\n  text-align: center;\n  margin-right: 8px;\n}\n\n.fileContainer {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  width: 100%;\n  padding: 12px;\n  padding-left: 24px;\n  padding-right: 24px;\n}\n\n.fileNameContainer {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-family: 'Roboto-Medium', 'Roboto';\n  font-weight: 600;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"button": `components-ImportEmployees-styles___button--_Cwdw`,
	"uploadContent": `components-ImportEmployees-styles___upload-content--jT8FM`,
	"textField": `components-ImportEmployees-styles___textField--sMh73`,
	"importEmployees": `components-ImportEmployees-styles___import-employees--af9zx`,
	"fileName": `components-ImportEmployees-styles___file-name--rtXDD`,
	"bottom": `components-ImportEmployees-styles___bottom--GOu1J`,
	"checkboxContainer": `components-ImportEmployees-styles___checkboxContainer--GsCMC`,
	"checkBoxText": `components-ImportEmployees-styles___checkBoxText--uIVCM`,
	"actions": `components-ImportEmployees-styles___actions--lotnd`,
	"downloadLink": `components-ImportEmployees-styles___download-link--iqSp0`,
	"actionsRight": `components-ImportEmployees-styles___actions-right--mv2s1`,
	"errorMessage": `components-ImportEmployees-styles___error-message--IYtGo`,
	"errorFileName": `components-ImportEmployees-styles___error-file-name--h2b6q`,
	"reportContent": `components-ImportEmployees-styles___report-content--LK21x`,
	"loadingContent": `components-ImportEmployees-styles___loading-content--O5Bd7`,
	"tabs": `components-ImportEmployees-styles___tabs--PaV7p`,
	"importEmployees": `components-ImportEmployees-styles___importEmployees--MLCRv`,
	"changeFile": `components-ImportEmployees-styles___changeFile--Tr4IT`,
	"fileCheckIcon": `components-ImportEmployees-styles___fileCheckIcon--DtBFh`,
	"fileContainer": `components-ImportEmployees-styles___fileContainer--bNcXq`,
	"fileNameContainer": `components-ImportEmployees-styles___fileNameContainer--zemRH`
};
module.exports = ___CSS_LOADER_EXPORT___;
